import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActionCard = ({ title, description, icon, iconColor, buttonText, onClick, badge }) => {
  return (
    <div className="bg-[var(--color-card)] border border-[var(--color-border)] rounded-lg p-4 md:p-6 hover:shadow-lg transition-all duration-300 group">
      <div className="flex items-start justify-between mb-4">
        <div className={`w-12 h-12 md:w-14 md:h-14 rounded-lg bg-opacity-10 flex items-center justify-center group-hover:scale-110 transition-transform duration-300`} style={{ backgroundColor: `${iconColor}20` }}>
          <Icon name={icon} size={24} color={iconColor} />
        </div>
        {badge && (
          <span className="px-2 py-1 bg-[var(--color-accent)] text-[var(--color-accent-foreground)] text-xs font-medium rounded-full">
            {badge}
          </span>
        )}
      </div>
      
      <h3 className="text-base md:text-lg font-semibold text-[var(--color-foreground)] mb-2">
        {title}
      </h3>
      
      <p className="text-sm text-[var(--color-muted-foreground)] mb-4 line-clamp-2">
        {description}
      </p>
      
      <Button
        variant="outline"
        fullWidth
        onClick={onClick}
        iconName="ArrowRight"
        iconPosition="right"
        iconSize={16}
      >
        {buttonText}
      </Button>
    </div>
  );
};

export default QuickActionCard;